import { DataTypeEnum } from "shared/constants/app-enums";
import { SeoModel } from "shared/models/seo-model";
import { TagModel } from "states/tag/tag.models";
import { UnitModel } from "states/unit/unit.models";
import { WareHouseModel } from "states/ware-house/ware-house.models";

export interface ProductModel {
  key: string;
  id: number;
  mainCategoryId: number;
  mainCategoryName?: string;
  relatedCategoryIds: number[];
  skuCode: string;
  images: string[];
  price?: number;
  promotionPrice?: number;
  promotionFromDate?: Date;
  promotionToDate?: Date;
  costPrice?: number;
  barCode?: string;
  name: string;
  mainVariationProductId?: number;
  accessoryIds: number[];
  isActive?: boolean;
  isVariation?: boolean;
  isAccessory?: boolean;
  isModifier: boolean;
  unitProducts: ProductModel[];
  unit?: UnitModel;
  unitRate?: number;
  isInventory?: boolean;
  slug: string;
  seoFields?: SeoModel;
  customizeTheme?: any;
  tags: TagModel[];
  variationAttributes: ProductVariationAttributeModel[];
  attributeGroups: ProductProductAttributeGroupModel[];
  inventories: InventoryModel[];
  sellingPrice: number;
  size: ProductSizeModel;
  sort: number;
  branchId?: number;
  wholesale?: WholesaleModel;
  priceBySubTotal?: PriceBySubTotalModel;
  mainUnitProductId?: number;
}

export interface AddUpdateProductModel {
  id?: number;
  mainCategoryId?: number;
  relatedCategoryIds?: number[];
  skuCode: string;
  images: string[];
  price?: number;
  promotionPrice?: number;
  promotionFromDate?: Date;
  promotionToDate?: Date;
  costPrice?: number;
  barCode?: string;
  name: string;
  mainVariationProductId?: number;
  accessoryIds?: number[];
  isActive?: boolean;
  isAccessory?: boolean;
  unitProducts?: AddUpdateProductModel[];
  unitId?: number;
  unitRate?: number;
  isInventory?: boolean;
  isModifier: boolean;
  slug: string;
  seoFields?: SeoModel;
  customizeTheme?: any;
  tagIds?: number[];
  variationAttributes: ProductVariationAttributeModel[];
  attributeGroups: ProductProductAttributeGroupModel[];
  size: ProductSizeModel;
  branchId?: number;
  wholesale?: WholesaleModel;
  priceBySubTotal?: PriceBySubTotalModel;
  mainUnitProductId?: number;
}

export interface SearchProductRequestModel {
  keyword?: string;
  categoryIds?: number[];
  productIds?: number[];
  page: number;
  pageSize: number;
  includeAccessory: boolean;
  includeChildrenUnitProduct: boolean;
  includeChildrenVariationProduct: boolean;
  wareHouseId?: number;
  isModifier?: boolean;
  branchId?: number;
}

export interface SearchProductModel {
  id: number;
  images: string[];
  websiteName: string;
}

export interface ProductAndCommentModel {
  id: number;
  websiteName?: string;
  slug: string;
  images: string[];
  numberOfNewComments: number;
  latestCommentTime: Date;
}

export interface ProductProductAttributeGroupModel {
  attributeGroupId: number;
  attributeGroupName: string;
  sort: number;
  attributes: ProductProductAttributeModel[];
}

export class ProductProductAttributeModel {
  constructor() {
    this.attributeName = "";
    this.sort = 0;
    this.values = [];
  }

  attributeId?: number;
  attributeName: string;
  sort: number;
  dataType?: DataTypeEnum;
  valueNumber?: number;
  valueString?: string;
  valueBoolean?: boolean;
  valueDate?: Date;
  values: ProductProductAttributeValueModel[];

  resetValue() {
    this.values = [];
    this.valueNumber = undefined;
    this.valueString = undefined;
    this.valueBoolean = undefined;
    this.valueDate = undefined;
  }
}
export interface ProductProductAttributeValueModel {
  valueId: number;
  value: string;
  sort: number;
}

export interface ProductVariationAttributeModel {
  variationAttributeId: number;
  variationName: string;
  variationAttributeValueId: number;
  variationValue: string;
  attributeSort?: number;
  attributeValueSort?: number;
}

export interface InventoryModel {
  id: string;
  wareHouse: WareHouseModel;
  onHandQuantity: number;
  orderedQuantity: number;
  upComingQuantity: number;
  totalStockQuantity: number;
  totalReadyForSaleQuantity: number;
  readyForSaleQuantity: number;
}

export interface ProductSizeModel {
  height: number;
  width: number;
  length: number;
  weight: number;
}

export interface WholesaleModel {
  items: WholesaleItemModel[];
}
export interface WholesaleItemModel {
  sellingPrice: number;
  quantityFrom: number;
  quantityTo: number;
  priceType: WholesalePriceType;
}

export enum WholesalePriceType {
  Unit,
  Total,
}

export interface PriceBySubTotalModel {
  items: PriceBySubTotalItemModel[];
}
export interface PriceBySubTotalItemModel {
  sellingPrice: number;
  subTotalFrom: number;
  subTotalTo: number;
}
